/**
 * Module-level holder for secrets fetched at sign-in from the arbor-v1
 * backend instead of shipped in the SPA bundle (PLAT-9905).
 *
 * `useSpaCredentials` populates this once the Clerk session is ready;
 * the editor render is gated on `ready` so non-React consumers
 * (`createGQLClient`, `new OpenAI(...)`) can synchronously read the
 * values via the getters below without each one plumbing the fetch.
 *
 * Getters throw if called before population. The gate makes this
 * unreachable in production; tests must call `setSpaCredentials`
 * (see `vitest.setup.ts`).
 */

interface SpaCredentials {
  datocmsReadToken: string;
  datocmsEnvironment: string;
  openaiKey: string;
}

let credentials: SpaCredentials | null = null;

export function setSpaCredentials(next: SpaCredentials): void {
  credentials = next;
}

export function clearSpaCredentials(): void {
  credentials = null;
}

export function hasSpaCredentials(): boolean {
  return credentials !== null;
}

export function getDatocmsReadToken(): string {
  if (!credentials) {
    throw new Error(
      'spaCredentials: read token requested before fetch completed — ensure useSpaCredentials has populated the holder',
    );
  }
  return credentials.datocmsReadToken;
}

export function getDatocmsEnvironment(): string {
  return credentials?.datocmsEnvironment ?? '';
}

export function getOpenAIKey(): string {
  if (!credentials) {
    throw new Error(
      'spaCredentials: OpenAI key requested before fetch completed — ensure useSpaCredentials has populated the holder',
    );
  }
  return credentials.openaiKey;
}
